import { ChipProps } from "@mui/material";
import { SalaryStatus } from "src/types/salary";

export const SALARY_STATUS_OPTIONS: Array<{ value: "" | SalaryStatus; labelKey: string }> = [
  { value: "", labelKey: "allStatuses" },
  { value: "unpaid", labelKey: "statusUnpaid" },
  { value: "partially_paid", labelKey: "statusPartiallyPaid" },
  { value: "paid", labelKey: "statusPaid" },
  { value: "over_paid", labelKey: "statusOverPaid" },
];

export const salaryStatusLabelKey = (status: SalaryStatus): string => {
  if (status === "paid") return "statusPaid";
  if (status === "partially_paid") return "statusPartiallyPaid";
  if (status === "over_paid") return "statusOverPaid";
  return "statusUnpaid";
};

// Map a salary status to a MUI semantic Chip color, matching the outlined
// status chips used elsewhere in the system (e.g. purchasing table).
export const salaryStatusColor = (status: SalaryStatus): ChipProps["color"] => {
  if (status === "paid") return "success";
  if (status === "partially_paid") return "warning";
  if (status === "over_paid") return "error";
  return "default";
};
